import React, { Component } from 'react';

import { s3CacheUrl } from '../Common/util';

export class DaultQuote extends Component {
  render() {
    return(
      <div className={"collabs-banner-quote dault-fg tile is-5"}>
        {`“I cannot do the same thing twice – I constantly explore new materials, ideas, combinations.”`}
        <div className={"collabs-banner-byline"}>
          —Julia Dault
        </div>
      </div>
    );
  }
}

export class DaultBio extends Component {
  render() {
    return(
      <div className={"collabs-bio"}>
        <div className={"collabs-divider dault-bg"} />

        <div className={"collabs-section white white tile is-ancestor"}>
          <div className={'collabs-bio-image-container tile is-5'}>
            <img className={"collabs-bio-image"} alt={"Julia Dault"} src={s3CacheUrl("https://s3.amazonaws.com/weft-public-assets/images/weft-shop-collab/dault/dault1weft-artist-portrait-388x350.jpg", 350)} />
          </div>
          <div className={"collabs-bio-header tile is-5"}>
            <h1>Accessing the Artist’s Hand</h1>
            <p>Through her site-specific sculptures and abstract paintings, Julia Dault emphasizes the role of the artist’s hand.</p>
          </div>
        </div>

        <div className={"collabs-section grey"}>
          <div className={"bio-content"}>
            <p>While she cautions against forcing an explicit connection between her artistic practices, 
            the physical act of creation is implicit in both Dault’s paintings and sculptures. 
            “I'm interested in transparency and directness. I use methods and materials that do not 
            have to be explained by an external source, but rather can be understood by being in front of 
            the work itself,” she says. “In an age of technological mediation, I'm also interested in the 
            primacy of the artist’s hand.”</p>
 
            <p>Dault’s anti-illusionist perspective is expressed when working in both mediums. 
            “I paint by building up layers of colors on a surface, and in the process create something 
            that might seem like a manufactured pattern,” she notes. “I then cover the dry painting 
            with a a topcoat of oil – often of just one color. Next, I’ll use tools – such as spatulas, 
            combs, tree branches, door handles – to pull away some of the topcoat while it’s still wet.” 
            By revealing the patterns and shapes she has composed underneath, including their imperfections, 
            Dault seeks to highlight the “humanness of the compositions.”</p>
 
            <p>This humanness is also accounted for in Dault’s sculptures: Feats of physical (and very human) 
            exertion, Dault assembles each on-site using materials like Plexiglas and Formica tethered 
            with cords and straps. She elaborates, “Each sculpture is titled with a date and time stamp 
            because they are made on-site by me. The titles convey to the viewer the duration of the 
            piece’s coming into being.”</p>
 
            <p>For her collaboration with Weft, Dault translated an existing painting into a fabric. 
            She notes, “I wanted to pick a painting with an unusual composition, a sense of motion 
            that would repeat interestingly. That thinking guided me to Mastermind.” She summarizes 
            this richly layered 2016 composition, “With Mastermind, my striving for anti-illusionism 
            or directness is apparent in the ‘floating forms,’ since the colors found within them 
            reveal each layer contained in the painting itself.</p>
          </div>
        </div>
      </div>
    );
  }
}